import { getToken } from './token';

// Token of the session that was flagged as migrated to V2. Keying the lock
// to the token means it releases on its own after logout / login as another user.
let lockedToken: string | null = null;

export const MIGRATION_API_LOCK_MESSAGE = 'migration-api-lock';

export const lockApiForMigration = (): void => {
  lockedToken = getToken();
};

export const isApiLockedForMigration = (): boolean =>
  !!lockedToken && lockedToken === getToken();
